import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray, titles } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	modalContainer: {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '600px',
		maxWidth: '90vw',
		maxHeight: '80vh',
		backgroundColor: 'white',
		border: `2px solid ${brandPrimary}`,
		borderRadius: '12px',
		boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
		zIndex: 9999,
		display: 'flex',
		flexDirection: 'column',
	},
	modalHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '16px 20px',
		borderBottom: `1px solid ${charmGray}`,
		backgroundColor: '#fafafa',
		borderRadius: '10px 10px 0 0',
	},
	modalHeaderContent: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
	},
	modalIcon: {
		width: '20px',
		height: '20px',
		color: brandPrimary,
	},
	modalTitle: {
		margin: 0,
		fontSize: '16px',
		fontWeight: 600,
		color: titles,
	},
	modalHeaderActions: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
	},
	iconButton: {
		background: 'none',
		border: 'none',
		padding: '4px',
		cursor: 'pointer',
		borderRadius: '4px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		':hover': {
			backgroundColor: '#f0f0f0',
		},
	},
	modalContent: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
	},
	conversationContainer: {
		flex: 1,
		overflow: 'auto',
		padding: '16px 20px',
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	messageContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
	},
	userMessage: {
		alignItems: 'flex-end',
	},
	assistantMessage: {
		alignItems: 'flex-start',
	},
	messageRole: {
		fontSize: '12px',
		fontWeight: 600,
		color: charmGray,
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	streamingIndicator: {
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
		fontSize: '10px',
		color: brandPrimary,
	},
	messageContent: {
		padding: '12px 16px',
		borderRadius: '12px',
		backgroundColor: '#f8f9fa',
		border: `1px solid ${charmGray}`,
		fontSize: '14px',
		lineHeight: '1.5',
		maxWidth: '85%',
	},
	loadingContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		padding: '16px',
	},
	loadingContainerWithColor: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		padding: '20px',
		justifyContent: 'center',
	},
	loadingText: {
		fontSize: '14px',
		color: charmGray,
	},
	inputContainer: {
		padding: '16px 20px',
		borderTop: `1px solid ${charmGray}`,
		backgroundColor: '#fafafa',
	},
	textarea: {
		width: '100%',
		minHeight: '60px',
		padding: '12px',
		border: `1px solid ${charmGray}`,
		borderRadius: '8px',
		fontSize: '14px',
		fontFamily: 'inherit',
		resize: 'vertical',
		outline: 'none',
		':focus': {
			borderColor: brandPrimary,
			boxShadow: `0 0 0 2px ${brandPrimary}20`,
		},
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: '12px',
	},
	progressContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '12px',
		width: '100%',
	},
	progressTextContainer: {
		textAlign: 'center',
	},
	progressSubtext: {
		fontSize: '12px',
		color: charmGray,
		marginTop: '4px',
	},
	progressBarContainer: {
		width: '100%',
		height: '8px',
		backgroundColor: '#e0e0e0',
		borderRadius: '4px',
		overflow: 'hidden',
	},
	progressBar: {
		height: '100%',
		backgroundColor: brandPrimary,
		borderRadius: '4px',
		transition: 'width 0.3s ease',
	},
	progressPercentage: {
		fontSize: '12px',
		fontWeight: 600,
		color: brandPrimary,
	},
	individualPhaseContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '20px',
		gap: '20px',
		overflow: 'auto',
		flex: 1,
	},
	individualAnalysesPreview: {
		width: '100%',
		borderTop: `1px solid ${charmGray}`,
		paddingTop: '16px',
	},
	synthesisAnalysesSection: {
		borderBottom: `1px solid ${charmGray}`,
		paddingBottom: '16px',
		marginBottom: '8px',
	},
});
